export interface PriceFormatOptions {
  currency?: string;
  locale?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  showDecimals?: boolean;
}

export const formatPrice = (price: number, options: PriceFormatOptions = {}) => {
  const {
    currency = "EUR",
    locale = "fr-FR",
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
    showDecimals = true,
  } = options;

  const formatOptions: Intl.NumberFormatOptions = {
    style: "currency",
    currency,
    minimumFractionDigits: showDecimals ? minimumFractionDigits : 0,
    maximumFractionDigits: showDecimals ? maximumFractionDigits : 0,
  };

  return new Intl.NumberFormat(locale, formatOptions).format(price);
};
